import Image from 'next/image'
import { Card, CardBody } from '@windmill/react-ui'
import { FeaturesCardContent } from '../../data/MachineLearningSolutionPageContent'

export const FeaturesCard = () => {
    const content = FeaturesCardContent
    const { cardData, description, heading } = content
    return (
        <>
            <h2 className="heading">{heading !== undefined && heading}</h2>
            <p className="description">
                {description !== undefined && description}
            </p>
            <div>
                <div
                    className="grid grid-cols-3 gap-8 ipad:grid-cols-2 tablet:grid-cols-1"
                    itemScope
                    itemType="https://schema.org/ListItem"
                >
                    {cardData !== undefined &&
                        cardData.map((card, index) => {
                            return (
                                <Card
                                    key={index + 1}
                                    className="base-card solutions"
                                >
                                    <CardBody className="text-center tablet:text-left card-body">
                                        <span className="block w-12 mx-auto image">
                                            <Image
                                                src={card.image.src}
                                                layout="responsive"
                                                alt={card.image.alt}
                                                width={48}
                                                height={48}
                                                itemProp="image"
                                            />
                                        </span>
                                        <h3
                                            className="title tablet:mb-0"
                                            itemProp="title"
                                        >
                                            {card.title}
                                        </h3>
                                    </CardBody>
                                </Card>
                            )
                        })}
                </div>
            </div>
        </>
    )
}
